import * as React from 'react';

function SvgIreland(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 58" {...props}>
    <path
      stroke="#DF4046"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M37.738 11.22h5.171v2.456s1.195 2.658 1.485 2.908c-.203.603-.449.652-.449.652h-.788l-.247.702h2.366v2.457s-4.926 3.26-5.025 3.711c-.493-.05-1.527 0-1.527 0s.099 3.36.394 3.56.443 1.305.099 1.605c-.345.3-.394.953-.394.953s-.296.652 0 .902c.197.452 0 3.01 0 3.01s-3.597 6.418-3.251 7.671c-1.083-.1-.493-.702-8.079-.602-.049 1.103 0 1.304 0 1.304s-6.798 1.505-8.03 2.257c-1.92.05-6.699-.25-6.699-.25v-.803s1.231-1.003 1.97-1.003c0 0-.245-.25-.788-.351-.541-.1-1.182.4-1.182.4l-1.527-.1s.049-.752.444-.902c.394-.151.64-.101.64-.101l-1.478-1.404-.985-.15s.197-1.354 1.675-1.755l1.429-.15.099-.552-2.956-.702s.393-.803 1.182-1.053 1.626.05 1.626.05l.444.301.591.2 1.281-1.956.739-.1.049-.502-.739-.25.197-1.003h1.034s1.38-.652 3.202-3.962c1.724-.2 2.02-.2 2.02-.2s-.592-1.304-.887-1.354-3.152.05-3.152.05-1.823-2.307-2.464-2.708c.148-.702.838-1.73.838-1.73l.936-.225.493-.752 1.379-.2s.492-.803-.099-1.003c-.592-.2-2.168-1.404-2.266-1.705-.1-.301.985-.301.985-.301l.591-1.103-.492-.602-.197-.903 1.182-.1.099.702s.21-.577 1.022-.389 2.845 1.392 3.104 1.58.96-.376.96-.376h.63l.553.64 1.478.112.073-.451-.48-.075-.148-.49s2.107-.639 2.882-1.052l.37-.489-1.552-.338-1.663-1.166.554-1.241h1.515l1.81-3.197h5.32l.85-1.141h.554s.37 1.366 1.441 1.554c.222.677.26.865.26.865l-.48.037.011.301z"
    />
    <path
      stroke="#DF4046"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M42.799 52.929A27 27 0 0 1 28.507 57C13.315 57 1 44.464 1 29S13.315 1 28.507 1c15.191 0 27.506 12.536 27.506 28 0 1.74-.155 3.443-.454 5.095"
    />
    <path
      stroke="#DF4046"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m44.484 44.887 2.21-2.234 2.207 2.234 6.257-6.33 2.208 2.234-8.465 8.564z"
    />
    <path
      stroke="#DF4046"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M61.144 46.773a4.035 4.035 0 0 0 0-5.635 4.02 4.02 0 0 1-1.146-2.819c0-2.2-1.753-3.985-3.915-3.985a3.88 3.88 0 0 1-2.769-1.166 3.865 3.865 0 0 0-5.536 0 3.88 3.88 0 0 1-2.769 1.166c-2.162 0-3.915 1.784-3.915 3.985 0 1.057-.412 2.071-1.146 2.819a4.035 4.035 0 0 0 0 5.635 4.02 4.02 0 0 1 1.146 2.819c0 2.2 1.753 3.985 3.915 3.985 1.039 0 2.035.42 2.769 1.166a3.865 3.865 0 0 0 5.536 0 3.88 3.88 0 0 1 2.769-1.166c2.162 0 3.915-1.784 3.915-3.985 0-1.057.413-2.071 1.146-2.819"
    />
    <path
      stroke="#DF4046"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M43.316 41.642c.965-3.13 3.837-5.399 7.23-5.399.932 0 1.825.172 2.65.486M57.647 46.656a7.7 7.7 0 0 1-3.312 3.982"
    />
  </svg>)
}
export default SvgIreland;
